






















































































import { Component, Prop, Model } from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import { BusEvent } from '@/models/bus';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import MetricPoints from '@/api/metricPoints';
import { InternationalizedField } from '@/api/common';
import InterfaceElement from '@/api/interfaceElement';
import ReferenceAlignment from '../api/referenceAlignment';

@Component({
  components: {
    modal: Modal,
    'edit-icon': EditIcon
  }
})
export default class FieldReferenceAlignments extends CommonVue {
  @Model('update') public reference_alignment_list!: ReferenceAlignment[];
  @Prop({ type: Boolean, default: false }) public disabled?: boolean;

  public reference_alignment: ReferenceAlignment = null;
  public isNewElement: boolean = false;
  public showModal: boolean = false;

  // noinspection JSMethodCanBeStatic
  public edit(element: ReferenceAlignment) {
    this.reference_alignment = element;
    this.isNewElement = false;
    this.showModal = true;
  }

  /* public newReferenceAlignment() {
            this.reference_alignment = new ReferenceAlignment();
            this.isNewElement = true;
            this.showModal = true;
        }*/

  public saveClicked() {
    if (!this.reference_alignment) {
      return;
    }

    this.busy = true;

    try {
      if (this.isNewElement) {
        this.reference_alignment_list.push(this.reference_alignment);
      }
      this.busy = false;
      this.showModal = false;
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not save reference alignment', e);
    }
  }

  public deleteClicked() {
    const newList = this.reference_alignment_list.filter((value) => {
      return value !== this.reference_alignment;
    });

    this.$emit('update', newList);
    this.showModal = false;
  }
}
